import React, { PureComponent } from 'react';
import { bool, string, func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import DOMPurify from 'dompurify';
import { addTargetBlankToSelector } from '@widergy/web-utils/lib/dom';

import { actionCreators as accountActions } from 'redux/accountHandlers';
import { DIGITAL_BILL_FORM } from 'constants/general';
import { SERVICE_ADHERENCE } from 'constants/reduxForms';

import ServiceAdherence from './layout';

const ACCOUNT_LIST = 'accountList';

class ServiceAdherenceContainer extends PureComponent {
  componentWillMount = () => this.props.dispatch(accountActions.getTermsOfService(DIGITAL_BILL_FORM));

  componentDidUpdate() {
    addTargetBlankToSelector('a');
  }

  createHtml = htmlInput => ({ __html: DOMPurify.sanitize(htmlInput) });

  handleCheckTerms = () => this.setState({ acceptedTerms: !this.state.acceptedTerms });

  render() {
    return (
      <div>
        <ServiceAdherence
          loading={this.props.termsOfServiceLoading || this.props.accountsLoading}
          termsOfService={this.createHtml(this.props.termsOfService)}
          onSubmit={this.props.onSubmit}
          accounts={this.props.accounts}
          accountListField={ACCOUNT_LIST}
        />
      </div>
    );
  }
}

ServiceAdherenceContainer.propTypes = {
  accountsLoading: bool,
  termsOfServiceLoading: bool,
  termsOfService: string,
  onSubmit: func.isRequired,
  accounts: shape({
    id: string,
    client_number: string,
    address: string
  })
};

export const accountsSelector = createSelector(
  store => store.account.accounts,
  store => store.account.addAccountFlow,
  store => store.account.relatedAccounts,
  (accounts, addAccountFlow, relatedAccounts) => {
    const accountList =
      addAccountFlow.currentStep === 2
        ? accounts.filter(account => account.client_number === addAccountFlow.initialAccount)
        : relatedAccounts.filter(account =>
            accounts.some(element => element.client_number === account.client_number.toString())
          );
    return accountList.map(account => ({
      id: account.client_number,
      client_number: account.client_number,
      address: account.address
    }));
  }
);

const formSelector = formValueSelector(SERVICE_ADHERENCE);

const mapStateToProps = (store, props) => ({
  termsOfService: store.account.termsOfService,
  termsOfServiceLoading: store.account.termsOfServiceLoading,
  accountsLoading: store.account.accountsLoading,
  accounts: accountsSelector(store, props),
  accountList: formSelector(store, ACCOUNT_LIST)
});

export default connect(mapStateToProps)(ServiceAdherenceContainer);
